var _rect, _rect2, _g, _rect3, _rect4, _path, _ellipse, _rect5, _ellipse2, _ellipse3, _ellipse4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallDocMositalmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 90,
    viewBox: "0 0 102 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.27515,
    y: 78.4287,
    width: 34.425,
    height: 3.85714,
    rx: 1.92857,
    fill: "#D0C8B5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57.375,
    y: 78.4287,
    width: 20.4,
    height: 3.85714,
    rx: 1.92857,
    fill: "#D0C8B5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6838_139886)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 27,
    width: 30,
    height: 27,
    fill: "#FF9690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4648 26.9424H85.5871L91.0582 54.2878H63.4648V26.9424Z",
    fill: "#B5A788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.848 26.9424L88.4413 54.2878H60.848V26.9424Z",
    fill: "#BEBFBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9334 24.1742H63.5316V20.7296C63.5316 19.372 64.0454 18.0143 65.0683 16.9828C66.0959 15.9466 67.4375 15.4285 68.7839 15.4285H71.6764C73.0228 15.4285 74.3691 15.9466 75.392 16.9828C76.4148 18.0191 76.9286 19.372 76.9286 20.7296V24.1742H76.9334Z",
    fill: "#FF9690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1707 52.3016C98.1231 51.7835 98.0422 51.2606 97.9233 50.7425C97.7235 49.8309 97.419 48.9626 97.0384 48.147L86.0201 24.6252C85.5967 23.7281 84.9307 22.9365 84.0363 22.3608C83.1419 21.7899 82.1475 21.5212 81.1628 21.5212H16.8228L10.4478 71.8752H23.8924C23.8924 65.1636 29.2873 59.7281 35.9383 59.7281C42.594 59.7281 47.9842 65.1636 47.9842 71.8752H61.6048C61.6048 65.1636 66.995 59.7281 73.6507 59.7281C80.3064 59.7281 85.6966 65.1636 85.6966 71.8752H98.2278V53.4674C98.223 53.0836 98.204 52.695 98.1707 52.3016ZM68.1606 49.7062C67.6182 49.7062 67.0806 49.4999 66.6715 49.0873C66.2576 48.67 66.0578 48.1278 66.0578 47.5857V30.2238C66.0578 29.7393 66.2386 29.2499 66.6097 28.8805C66.976 28.5159 67.4565 28.324 67.9417 28.324H78.6889C79.4643 28.324 80.2493 28.5447 80.9439 29.0052C81.6433 29.461 82.1523 30.0991 82.4615 30.8139L88.9697 45.8683C89.3218 46.6886 89.2742 47.6625 88.7509 48.4637C88.2276 49.2696 87.3617 49.7062 86.4768 49.7062H68.1606Z",
    fill: "#F2F2F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9331 61.1865C30.0767 61.1865 25.3335 65.9744 25.3335 71.88C25.3335 77.7809 30.0767 82.5687 35.9331 82.5687C41.7896 82.5687 46.5328 77.7809 46.5328 71.88C46.5328 65.9696 41.7943 61.1865 35.9331 61.1865ZM35.9331 76.2073C33.5639 76.2073 31.6419 74.2691 31.6419 71.88C31.6419 69.4909 33.5639 67.5527 35.9331 67.5527C38.3024 67.5527 40.2244 69.4909 40.2244 71.88C40.2291 74.2691 38.3071 76.2073 35.9331 76.2073Z",
    fill: "#827657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.798 61.1865C67.9416 61.1865 63.1984 65.9744 63.1984 71.88C63.1984 77.7809 67.9416 82.5687 73.798 82.5687C79.6497 82.5687 84.3976 77.7809 84.3976 71.88C84.3976 65.9696 79.6497 61.1865 73.798 61.1865ZM73.798 76.2073C71.4288 76.2073 69.5068 74.2691 69.5068 71.88C69.5068 69.4909 71.4288 67.5527 73.798 67.5527C76.1672 67.5527 78.0892 69.4909 78.0892 71.88C78.094 74.2691 76.172 76.2073 73.798 76.2073Z",
    fill: "#827657"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7176 51.8892L10.6567 71.5394H24.1013C24.1013 64.8278 29.4963 59.3923 36.1472 59.3923C42.8029 59.3923 48.1932 64.8278 48.1932 71.5394H61.8138C61.8138 64.8278 67.204 59.3923 73.8597 59.3923C80.5154 59.3923 85.9056 64.8278 85.9056 71.5394H98.4368V53.1316C98.432 52.7478 98.413 52.3593 98.3797 51.9659C98.3773 51.9403 98.3749 51.9147 98.3724 51.8892H12.7176Z",
    fill: "#D0C8B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6594 55.6405C99.6594 54.1917 99.0552 52.9443 98.1941 52.3687V58.9124C99.0552 58.3367 99.6594 57.0941 99.6594 55.6405Z",
    fill: "#FAD7B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.368 69.6541C100.368 70.8246 99.4263 71.7745 98.2655 71.7745H88.8029C87.6421 71.7745 86.7001 70.8246 86.7001 69.6541L87.566 65.1205C87.566 63.9499 88.508 63 89.6688 63H99.1314C100.292 63 101.234 63.9499 101.234 65.1205L100.368 69.6541Z",
    fill: "#9A8960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0433 69.6538C20.0433 70.8243 19.1013 71.7742 17.9405 71.7742H8.47792C7.3171 71.7742 6.37512 70.8243 6.37512 69.6538L7.01262 65.1201C7.01262 63.9495 7.9546 62.9996 9.11542 62.9996H18.578C19.7388 62.9996 20.6808 63.9495 20.6808 65.1201L20.0433 69.6538Z",
    fill: "#9A8960"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 35.5,
    r: 6.5,
    fill: "#F6F4F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 32,
    width: 2,
    height: 7,
    fill: "#FF9690"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 34.5,
    width: 2,
    height: 7,
    transform: "rotate(90 34 34.5)",
    fill: "#FF9690"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.56074,
    height: 6.40185,
    rx: 1.28037,
    transform: "matrix(0.704142 -0.710059 0.704142 0.710059 58.6499 9.53247)",
    fill: "#FF9690"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 69.4558,
    y: 5.1106,
    width: 2.55,
    height: 6.42857,
    rx: 1.275,
    fill: "#FF9690"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.9001 6.42864C96.9001 9.26896 92.048 11.5715 86.0626 11.5715C80.0772 11.5715 75.2251 9.26896 75.2251 6.42864C75.2251 3.58832 76.8897 3.21436 82.8751 3.21436C88.8605 3.21436 96.9001 3.58832 96.9001 6.42864Z",
    fill: "#F6F4F0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.0503,
    cy: 4.5,
    rx: 6.37501,
    ry: 4.5,
    fill: "#F6F4F0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.56074,
    height: 6.40185,
    rx: 1.28037,
    transform: "matrix(-0.704142 -0.710059 -0.704142 0.710059 82.811 9.53247)",
    fill: "#FF9690"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.3251,
    cy: 14.7857,
    rx: 11.475,
    ry: 5.78571,
    fill: "#F6F4F0"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.3,
    cy: 7.71429,
    rx: 15.3,
    ry: 7.71429,
    fill: "#F6F4F0"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.425,
    cy: 7.71429,
    rx: 11.475,
    ry: 7.71429,
    fill: "#F6F4F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6838_139886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.6251,
    height: 78.4286,
    fill: "white",
    transform: "translate(6.375 11.5713)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallDocMositalmed);
export default __webpack_public_path__ + "static/media/call_doc_mositalmed.fb7e8de82910b2485420aef485d32df2.svg";
export { ForwardRef as ReactComponent };